import { MENU_KIDS } from '@app/models/record.model';
import { User } from '@app/models/user.model';
import { buddyUtils } from '@care-connect-japan/ckweblib';
import * as moment from 'moment';

export const guidGenerator = () => {
  let S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

export const getCustomPropertyValue = (element: HTMLElement, customPropertyName: string) => {
  let style = window.getComputedStyle(element);
  return style.getPropertyValue(customPropertyName);
}

export const getZoomrateFromElement = () => {
  let zoomrate = getCustomPropertyValue(document.body, '--zoomrate');
  if (!zoomrate) return 1;
  try {
    return parseFloat(zoomrate);
  } catch (error) {
    return 1;
  }
}

export const xmlToJson = (xml: string) => {
  try {
    const xmlDoc = new DOMParser().parseFromString(xml || '', 'text/xml');
    let convertDataArray = xmlDocToJson(xmlDoc.children);
    return convertDataArray[0].children;
  } catch (error) {
    return [];
  }
}

const xmlDocToJson = (xmlItems: HTMLCollection) => {
  const items = [];
  const xmlArr = Array.from(xmlItems);
  for (const xml of xmlArr) {
    const tempItem: any = {};
    tempItem.tagName = xml.localName;
    for (const attr of Array.from(xml.attributes)) {
      // get full attribute name 
      tempItem[attr.name] = attr.value;
    }
    if (xml.children.length === 0 && xml.innerHTML) {
      tempItem.innerContent = xml.innerHTML;
    }
    if (xml.children.length > 0) {
      // If item contain rtf tag
      if (xml.children.length === 1 && xml.innerHTML.includes('<rtf>') && !xml.innerHTML.includes('<itm')) {
        // remove rtf in innerContent
        let sIndex = xml.innerHTML.indexOf('<rtf>');
        let eIndex = xml.innerHTML.indexOf('</rtf>');
        eIndex += 6;                      // 6 is number char of '</rtf>'
        let rtfStr = xml.innerHTML.substring(sIndex, eIndex);
        let lastStr = xml.innerHTML.replace(rtfStr, '');
        tempItem.innerContent = lastStr;
        tempItem['rtf'] = xmlDocToJson(xml.children);
      } else {
        tempItem['children'] = xmlDocToJson(xml.children);
      }
    }
    items.push({ ...tempItem });
  }
  return items;
}

export const applyContentToTemplate = (rawContent: string, template: string, isRawContent = true) => {
  let content = '';
  const container = document.createElement('div');
  container.innerHTML = template;
  const selector = container.querySelector('label');
  
  if (!isRawContent) {
    content = rawContent;
    selector?.prepend(content);
    return container.innerHTML;

  }

  if (rawContent.startsWith('「')) {
    const startIndex = rawContent.indexOf('「');
    const endIndex = rawContent.indexOf('」');
    content = rawContent.slice(startIndex, endIndex + 1);
  }
  else {
    content = rawContent;
  }

  selector?.prepend(content);
  return container.innerHTML;
}

export const requestToNoteUpdate = (url: string) => url.includes('/note/update');
export const requestToScheduleResult = (url: string) => url.includes('/schedule/result');
export const requestToFacilityuserList = (url: string) => url.includes('/facilityuser/list');

export const isKIROKU = localStorage.getItem('menu') === MENU_KIDS.KIROKU;
export const isHAISETSU = isKIROKU && localStorage.getItem('menuItem') === MENU_KIDS.HAISETSU;
export const isONDOBAN = isKIROKU && localStorage.getItem('menuItem') === MENU_KIDS.ONDOBAN;
export const isONDOBANICHIRAN = isKIROKU && localStorage.getItem('menuItem') === MENU_KIDS.ONDOBANICHIRAN;
export const isJIBUNGAIRETA = isKIROKU && localStorage.getItem('menuItem') === MENU_KIDS.JIBUNGAIRETA;
export const isHITORIBUNNO = isKIROKU && localStorage.getItem('menuItem') === MENU_KIDS.HITORIBUNNO;
export const isNOTKYOSCREENS = isKIROKU && !localStorage.getItem('selectedMenu')?.startsWith('今日') && !localStorage.getItem('selectedMenu')?.startsWith('業務連絡');
export const isBUSINESSCOMMUNICATION = isKIROKU && localStorage.getItem('selectedMenu')?.startsWith('業務連絡');
export const eqSet = (xs: Set<any>, ys: Set<any>) => xs.size === ys.size && [...xs].every((x) => ys.has(x));
export const defaultNote = (ttlkbn: string, ttlcd: string, user: User) => {
  const defaultDate = moment().format('YYYY-MM-DDTHH:mm:ss');
  const objectcd = localStorage.getItem('objectcd') || '';
  const extract = buddyUtils.default.extractOffice(objectcd);
  return {
    "displayOption": {
      "readable": true,
      "writable": true,
      "isLocked": false
    },
    "objkbn": "00",
    "objcd": user.daicd,
    "objnm": user.family,
    "noteid": null,
    "sdate": defaultDate,
    "edate": defaultDate,
    "corpcd": extract.corpcd,
    "officecd": extract.officecd,
    "blockcd": extract.blockcd,
    "subcd": extract.subcd,
    "unitcd": "000",
    "ttlkbn": ttlkbn,
    "ttlcd": ttlcd,
    "ttlnm": null,
    "ownstfcd": null,
    "ownstfnm": "ニャット職員　一",
    "ownunitcd": objectcd,
    "ownseccd": null,
    "ownteamcd": null,
    "ownjobcd": "40",
    "odrstfcd": null,
    "odrstfnm": null,
    "odrunitcd": null,
    "odrseccd": null,
    "odrteamcd": null,
    "odrjobcd": null,
    "schedroomcd": null,
    "schedbedcd": null,
    "composition": 0,
    "notekbn": 0,
    "dockbn": 1,
    "schedatr": 0,
    "resultatr": 0,
    "draftatr": 0,
    "pickupflg": 0,
    "lifeflg": 0,
    "spflg": 0,
    "urgflg": 0,
    "admstat": null,
    "delstat": null,
    "lockflg": null,
    "lockstfcd": null,
    "r": 63,
    "w": 31,
    "x": 0,
    "contents": null,
    "relation": null,
    "history": null,
    "ordering": null,
    "glid": null,
    "glcd": null,
    "glnm": null,
    "msgkbn": null,
    "sndstfcd": null,
    "sndstfnm": null,
    "snddate": null,
    "subject": null,
    "request": null,
    "sendinfo": null,
    "rcvdate": null,
    "rcvstat": null,
    "rcvmemo": null,
    "ifflg": null,
    "ifversion": null,
    "ifdocnum": null,
    "ifordernum": null,
    "ifsliptype": null,
    "ifcontents": null,
    "ifcliniccd": null,
    "ifclinicnm": null,
    "ifinoutkbn": null,
    "ifinoutkbnnm": null,
    "ificd1": null,
    "ificd2": null,
    "ifparentdocnum": null,
    "ifrelatedordernum": null,
    "ifreqordernum": null,
    "ifwardcd": null,
    "ifwardnm": null,
    "v2contents": "<content hisno=\"0\"></content>",
    "v2relation": null,
    "v2history": null,
    "v2ordering": null,
    "v2sendinfo": null,
    "v2ifcontents": null,
    "insstfcd": null,
    "insdate": null,
    "updstfcd": null,
    "upddate": null
  }
}

export function withTimeout<T>(
  fn: (signal: AbortSignal) => Promise<T>,
  ms: number
): Promise<T> {

  const controller = new AbortController();

  const timeoutId = setTimeout(() => {
    controller.abort();
  }, ms);

  return fn(controller.signal)
    .finally(() => clearTimeout(timeoutId));
}

export function createObjCd(
  corpcd: string,
  officecd: string,
  blockcd: string,
  unitcd: string
) {
  return `${corpcd}${officecd}${blockcd}00${unitcd}`;
};

export const corpCd = (objectCd: string) => objectCd.substring(0, 1);
export const officeCd = (objectCd: string) => objectCd.substring(1, 3);
export const blockCd = (objectCd: string) => objectCd.substring(3, 5);
export const subCd = (objectCd: string) => objectCd.substring(5, 7);
export const unitCd = (objectCd: string) => objectCd.substring(7, 10);
export const getRandomColor = () => {
  const colors = [
    '#FFB6C1',
    '#87CEFA',
    '#98FB98',
    '#FFD700',
    '#DDA0DD',
    '#9ca1d1',
    '#d65651',
    '#859ecc',
    '#43ca8b',
    '#86b469',
    '#AFEEEE'
  ];

  return colors[Math.floor(Math.random() * colors.length)];
}